import React from 'react';

import HeaderShowContact from './component';

export default React.memo(HeaderShowContact);
